import React from "react";
import Table from "../../../../components/Tabla/Table";

const ListaActividades = ({
  actividades,
  loading,
}) => {

  return (
    <Table
      id="lista-actividades-table"
      title=""
      columns={[
        {
          title: 'Código',
          field: 'codigo',
          width: 90
        },
        {
          title: 'Actividad',
          field: 'actividadEconomicaMs.descripcionActividad',
          width: 150,
        },
        {
          title: 'Es principal',
          field: 'esPrincipal',
          render: (rowData) => <p> {rowData.esPrincipal === 'S' ? 'Si' : 'No'} </p>,
          width: 150,
        },
      ]}
      data={actividades}
      loading={loading}
    />
  );
};

export default ListaActividades;